module.exports = __webpack_public_path__ + "img/L_2D.f99bcb74.png";